import { Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';

export type TThumbnailImageModel = typeof ThumbnailImageModel;
export type ThumbnailImageModelInstance = Instance<TThumbnailImageModel>;
export interface IThumbnailImageModelIn extends SnapshotIn<TThumbnailImageModel> {}
export interface IThumbnailImageModelOut extends SnapshotOut<TThumbnailImageModel> {}
export interface IThumbnailImageModel extends ThumbnailImageModelInstance {}

export const ThumbnailImageModel = types
  .model({
    projectId: types.string,
    originalImageId: types.identifier,
    thumbnailUrl: types.string,
    usageQuantity: types.number,
    fileLastModified: types.number,
    fileAddedTimestamp: types.number,
    fileName: types.string,
    width: types.number,
    height: types.number,
    source: types.string,
  })
  .volatile<{
    isSelected: boolean;
  }>(self => ({
    isSelected: false,
  }))
  .actions(self => ({
    select() {
      self.isSelected = true;
    },
    deselect() {
      self.isSelected = false;
    },
    setUsageQuantity(value: number) {
      self.usageQuantity = value;
    },
  }));
